// src/internal/components/help-center-panel/functions/sanitization.ts
import DOMPurify from "dompurify";
var sanitization = (html) => {
  const sanitizeConfig = {
    ALLOWED_URI_REGEXP: /^(?:(?:https?|ftp):|[^&:\/?#]*(?:[\/?#]|$))/i,
    ADD_TAGS: ["a", "iframe"],
    ADD_ATTR: [
      "target",
      "allow",
      "allowfullscreen",
      "frameborder",
      "height",
      "width",
      "sandbox"
    ]
  };
  DOMPurify.addHook("afterSanitizeAttributes", function(node) {
    var _a;
    if ("target" in node) {
      node.setAttribute("target", (_a = node.getAttribute("target")) != null ? _a : "_blank");
      node.setAttribute("rel", "noreferrer");
    }
  });
  return DOMPurify.sanitize(html, sanitizeConfig);
};

export {
  sanitization
};
